'use client';
import Bars from '@/app/_components/ui/icons/Bars.svg';
import User from '@/app/_components/ui/icons/User.svg';
import React from 'react';
import Link from 'next/link';
import { signOut, useSession } from 'next-auth/react';
import TopHeader from './TopHeader';
import Searchbar from './Searchbar';
import UserMenu from './UserMenu';
import CartMenu from './CartMenu';
import Image from 'next/image';
import MobileMenu from './MobileMenu';
import { useState, useEffect } from 'react';
import CategoryMenu from './CategoryMenu';
import menuData from '../../../preBuildScripts/data.json';
import DropDownMenu from './DropDownMenu';
import PreloadResources from '../seo/PreloadResources';
import { usePathname } from 'next/navigation';
import Invoice from '@/app/_components/ui/icons/Invoice.svg';
import useProformaInvoice from '@/app/_hooks/useProformaInvoice';

export default function Header({ object }) {
  const { data: session } = useSession();
  const pathname = usePathname();
  const isUser = !!session?.user;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { invoice } = useProformaInvoice();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true); // Mark component as mounted
  }, []);
  const onCloseModalHandler = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname]);
  return (
    <header id="header">
      <PreloadResources />
      <TopHeader />
      <>
        <div className="middle-header hidden md:block">
          <div className="flex container pt-4 pb-4 justify-between align-center gap-2">
            <div className="col-right flex-auto w-60 flex justify-between items-start">
              <Link href="/">
                <Image
                  src="/images/barghchi-logo.svg"
                  alt="فروشگاه برقچی"
                  height={40}
                  width={127}
                  loading="eager"
                  fetchPriority={'low'}
                />
              </Link>
              <Searchbar />
            </div>
            <div className="col-left flex-auto w-40 flex justify-end items-center">
              <div className="head-enquiry cursor-pointer md:block hidden lg:hidden">
                <Link href="/page/enquiry">
                  <div className=" bg-color-primary text-white text-sm  font-medium py-2 px-3 rounded-lg">
                    درخواست پیش فاکتور
                  </div>
                </Link>
              </div>
              <UserMenu session={session} />
              <CartMenu session={session} />
            </div>
          </div>
        </div>
        <div className="shadow-[0_4px_4px_0_#eaeced40] mt-3">
          <nav className="header-bottom hidden  container md:flex justify-between items-center">
            <ul className="nav-main-menu flex justify-between items-start text-sm  pb-5 relative w-full">
              <div className="flex justify-start items-center">
                {menuData?.menu.map((item, index) => (
                  <React.Fragment key={item.id}>
                    {index === 0 ? (
                      <>
                        <CategoryMenu menu={item} />
                      </>
                    ) : (
                      <DropDownMenu
                        key={index}
                        item={item}
                        last={
                          index === menuData?.menu.length - 1 ? true : false
                        }
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>
              <div className="head-enquiry cursor-pointer md:hidden lg:block">
                <Link href="/page/proforma-invoice/">
                  <div className=" bg-light-green-100 flex items-center border border-green-heavy text-green-heavy font-medium py-2 px-5 rounded-lg">
                    <Invoice fill="#08A54A" />
                    <span className="pr-2">صدور پیش فاکتور</span>
                    {mounted && invoice?.items.length > 0 && (
                      <div className="absolute -top-3 -left-3 text-white bg-red-300 rounded-full w-5 h-5 text-center">
                        {invoice?.items.length}
                      </div>
                    )}
                  </div>
                </Link>
              </div>
            </ul>
          </nav>
        </div>
        {/* Responsive header for size xs to md */}
        <div className="mobile-header block md:hidden">
          <div className="container shadow-y">
            <div className="mobile-top-header flex py-3.5 items-center justify-between">
              <div className="flex justify-between items-center  w-full">
                <div
                  className="mobile-navigation border-l border-light-gray-300 p-1 xs:ml-2 sm:ml-5"
                  onClick={() => setMobileMenuOpen((current) => !current)}
                >
                  <Bars />
                </div>
                <MobileMenu
                  toggle={mobileMenuOpen}
                  items={menuData?.menu}
                  onCloseModalHandler={onCloseModalHandler}
                />
                <div className="flex justify-between items-start w-full ">
                  <Link href="/page/proforma-invoice/">
                    <div className=" bg-light-green-100 flex relative items-center border text-sm border-green-heavy text-green-heavy font-medium py-1 px-5 rounded-lg">
                      <Invoice fill="#08A54A" />
                      <span className="pr-2">صدور پیش فاکتور</span>

                      {mounted && invoice?.items.length > 0 && (
                        <div className="absolute -top-3 -left-3 text-white bg-red-300 rounded-full w-5 h-5 text-center">
                          {invoice?.items.length}
                        </div>
                      )}
                    </div>
                  </Link>

                  <div className="mobile-logo">
                    <Link href="/">
                      <Image
                        src="/images/barghchi-logo.svg"
                        alt="فروشگاه برقچی"
                        height={31}
                        width={99}
                        loading="eager"
                        fetchPriority={'low'}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile-bottom-header  block md:hidden border-t border-light-gray-300 py-3.5 flex justify-between">
              <div className="mobile-extra-menu-item flex-1 flex relative items-center justify-end">
                <Searchbar />
                <div className="px-3">
                  {isUser ? (
                    <Link href="/profile">
                      <User stroke="#2A75BB" />
                    </Link>
                  ) : (
                    <Link href="/users/login">
                      <User stroke="#2A75BB" />
                    </Link>
                  )}
                </div>
                <div className="px-3">
                  <CartMenu session={session} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </header>
  );
}
